import { setupLayouts } from 'virtual:generated-layouts';
// eslint-disable-next-line import/no-unresolved
import { createRouter, createWebHistory } from 'vue-router/auto';
import { routes } from './additional-routes';
import { setupGuards } from './guards';
import { appBackCoordinator } from '@/utils/appBackCoordinator';

function recursiveLayouts(route) {
  if (route.children) {
    for (let i = 0; i < route.children.length; i++)
      route.children[i] = recursiveLayouts(route.children[i]);
    return route;
  }
  return setupLayouts([route])[0];
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) return { el: to.hash, behavior: 'smooth', top: 60 };
    if (savedPosition) return savedPosition;
    // 메인 페이지는 컴포넌트 내에서 스크롤 위치를 직접 제어
    if (to.path === '/main') return false;
    return { top: 0 };
  },
  extendRoutes: (pages) => [
    ...[
      ...pages,
      ...routes,
      {
        path: '/:catchAll(.*)', // 정의되지 않은 경로에 대한 처리
        redirect: '/main', // 없는 페이지에 접속 시 /main으로 리디렉션
      },
    ].map((route) => recursiveLayouts(route)),
  ],
});

setupGuards(router);
appBackCoordinator.attachRouter(router);
router.afterEach((to, from, failure) => {
  appBackCoordinator.notifyNavigationSettled(to, from, failure);
});
export { router };
export default function (app) {
  app.use(router);
}
